// extracted by mini-css-extract-plugin
export default {"card":"ApplicationSentContent_card__wAHoy"};